import mvpdVerifiedTemplate from "templates/liveTV/_messageMVPDVerified.tpl";
import BaseLiveTVMessage from "components/messageBoxes/BaseLiveTVMessage";

export default class MVPDVerifiedMessage extends BaseLiveTVMessage {

    constructor(parentContainer, data) {
        super(parentContainer, mvpdVerifiedTemplate(data));

        /**
         * @private
         */
        this.onSignInClickedCallback = null;

        /**
         * @private
         */
        this.onSignUpClickedCallback = null;

        /**
         * @private
         */
        this.onRegLaterClickedCallback = null;

        /**
         * @priate
         */
        this.onStartWatchClickedCallback = null;
    }

    onSignInClicked(callback) {
        this.onSignInClickedCallback = callback;
    }

    onSignUpClicked(callback) {
        this.onSignUpClickedCallback = callback;
    }

    onRegLaterClicked(callback) {
        this.onRegLaterClickedCallback = callback;
    }

    onStartWatchClicked(callback) {
        this.onStartWatchClickedCallback = callback;
    }

    show() {
        super.show();

        let self = this;

        const signInCTA = this.me.querySelector('#mvpd__signin')
        const signUpCTA = this.me.querySelector('#mvpd__signup')
        const startWatchingCTA = this.me.querySelector('#mvpd__getstarted')
        const regLaterCTA = this.me.querySelector('#mvpd__reg-later')

        if (signInCTA) {
            signInCTA.addEventListener('click', (e) => {
                e.preventDefault();
                self.onSignInClickedCallback();
            });
            signInCTA.addEventListener('keydown', (e) => {
                e.preventDefault();
                self.onSignInClickedCallback();
            });
        }

        if (signUpCTA) {
            signUpCTA.addEventListener('click', (e) => {
                e.preventDefault();
                self.onSignUpClickedCallback();
            });
            signUpCTA.addEventListener('keydown', (e) => {
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    self.onSignUpClickedCallback();
                }
            });
        }

        if (startWatchingCTA) {
            startWatchingCTA.addEventListener('click', (e) => {
                e.preventDefault();

                self.onStartWatchClickedCallback();
            });
            startWatchingCTA.addEventListener('keydown', (e) => {
                if (e.key === "Enter" || e.key === ' ') {
                    e.preventDefault();
                    this.onStartWatchClickedCallback();
                }
            });
        }

        if (regLaterCTA){
            regLaterCTA.addEventListener('click', (e) => {
                e.preventDefault();

                self.onRegLaterClickedCallback();
            });
        }
    }

    displayProviderIcon(provider) {
        if(this.me) {
            if(provider.providerLogo != null) {
                let mvpdLogo = document.createElement('img');
                mvpdLogo.src = `https://wwwimage-secure.cbsstatic.com/base/${provider.providerLogo}`;
                mvpdLogo.alt = provider.providerName;
                this.me.querySelector('#slate_provider_icon').appendChild(mvpdLogo);
            } else {
                let mvpdName = document.createElement('h2');
                mvpdName.innerHTML = provider.providerName;
                this.me.querySelector('#slate_provider_icon').appendChild(mvpdName);
            }
        }
    }

}
